<template>
  <q-form class="row q-col-gutter-lg">
    <div class="col-xs-12 col-md-grow">
      <q-input
        ref="phoneNumber"
        v-model="phoneNumber"
        outlined
        autocomplete="tel"
        type="tel"
        :label="$t('payment.phoneNumber')"
        :rules="[
          v => !!v || $t('payment.validation.phoneNumber.required'),
          v => v && v.length >= 7 || $t('payment.validation.phoneNumber.tooShort'),
        ]"
      />
    </div>
  </q-form>
</template>

<script>
import { debounce } from 'quasar';
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'PaymentAurForm',

  data() {
    return {
      phoneNumber: '',
    };
  },

  computed: {
    ...mapState('order', ['paymentData']),
  },

  watch: {
    phoneNumber() {
      this.$nextTick(this.submitForm);
    },
  },

  mounted() {
    this.$refs.phoneNumber.validate();
  },

  created() {
    // Debouncing because of validation
    this.submitForm = debounce(this.submitForm, 200);

    if (this.paymentData) {
      this.phoneNumber = this.paymentData.phoneNumber;
    }
  },

  methods: {
    ...mapMutations('order', ['updatePaymentData']),

    validateForm() {
      return !this.$refs.phoneNumber.hasError;
    },

    submitForm() {
      if (this.validateForm()) {
        this.updatePaymentData({
          phoneNumber: this.phoneNumber,
        });
      }
    },
  },
};
</script>
